import { StringFormatter, useTranslation } from '@pp/core';

/**
 * A custom hook to detect changes in the window object's media query.
 * @param {string} query - Media query string.
 * @returns {boolean} - Current match status of the media query.
 */
export const useTranslationText = (tk: string, dynamicValues?: any[]): string => {
  const { translations, isFetching } = useTranslation();
  const text = translations[tk] || tk;
  const formattedText = StringFormatter(text, dynamicValues || []);

  if (isFetching) {
    return tk;
  }

  return formattedText;
};
